import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "news" }
const _hoisted_2 = { class: "news-banner" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "news-content" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "content" }
const _hoisted_8 = { class: "title" }
const _hoisted_9 = { class: "detail" }
const _hoisted_10 = { class: "createTime" }

import { ref, watch, onMounted, onUnmounted, reactive } from 'vue'
import { selectCommonElement, addConsult } from '@/api'
import router from '@/router';
import { asynchronousRetrieval } from '@/utils'

export default /*@__PURE__*/_defineComponent({
  __name: 'NewsView',
  setup(__props) {

const loadUrl: any = ref({})

const newsList: any = ref([])

const toOtherPath = (relatedHtmlId: number, title: string) => {
  router.push(`/details?relatedHtmlId=${relatedHtmlId}`)
}

onMounted(async () => {
  selectCommonElement({ columnId: 5, appId: 2 }).then((res: any) => {
    newsList.value = [...res].map((e: any) => {
      const date = new Date(e.createTime)
      const y = date.getFullYear();
      const m = date.getMonth() + 1;
      const d = date.getDate();
      const h = date.getHours();
      const mx = date.getMinutes();
      const s = date.getSeconds();
      e.createTime = `${y}-${m}-${d} ${h}:${mx}:${s}`
      return e;
    })
  })

  const news: any = await asynchronousRetrieval('webimg/images/about_us/news.png');
  loadUrl.value = { news }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: loadUrl.value.news
      }, null, 8, _hoisted_3),
      _cache[0] || (_cache[0] = _createElementVNode("div", null, "公司动态", -1))
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(newsList.value, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          onClick: ($event: any) => (toOtherPath(item.relatedHtmlId, item.title))
        }, [
          _createElementVNode("div", null, [
            _createElementVNode("img", {
              src: item.ossPath
            }, null, 8, _hoisted_6)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, _toDisplayString(item.title), 1),
            _createElementVNode("div", _hoisted_9, _toDisplayString(item.introduction), 1),
            _createElementVNode("div", _hoisted_10, _toDisplayString(item.createTime.slice(0, 10)), 1)
          ])
        ], 8, _hoisted_5))
      }), 128))
    ])
  ]))
}
}

})